import { getMainApi, getSecureAccountsApi, postMainApi, putMainApi, deleteMainApi } from "@Shared/utils/ajax";
export const getAll = () => {
  const endpoint = "/drip/campaign";
  return getMainApi({}, endpoint);
};
export const getById = (id, paginationData) => {
  const {
    offset = 0,
    limit = 1,
    searchString = ""
  } = paginationData || {};
  const endpoint = `/drip/campaign/${id}`;
  return getMainApi({
    offset,
    limit,
    searchString
  }, endpoint);
};
export const getAutomation = () => {
  return getSecureAccountsApi({}, "/customize/automation");
};
export const downloadGlobalStatistics = id => {
  const endpoint = `/drip/campaign/${id}/statistics/download`;
  return getMainApi({}, endpoint);
};
export const create = name => {
  const endpoint = "/drip/campaign";
  return postMainApi({
    name
  }, endpoint);
};
export const addTrigger = (campaignId, data) => {
  const endpoint = `/drip/campaign/${campaignId}/trigger`;
  return postMainApi(data, endpoint);
};
export const addEmail = (campaignId, data) => {
  const endpoint = `/drip/campaign/${campaignId}/stage`;
  return postMainApi(data, endpoint);
};
export const toggleActive = campaignId => {
  const endpoint = `/drip/campaign/${campaignId}/active`;
  return putMainApi({}, endpoint);
};
export const editCampaign = (campaignId, data) => {
  const endpoint = `/drip/campaign/${campaignId}`;
  return putMainApi(data, endpoint);
};
export const editTrigger = (campaignId, triggerId, data) => {
  const endpoint = `/drip/campaign/${campaignId}/trigger/${triggerId}`;
  return putMainApi(data, endpoint);
};
export const editEmail = (campaignId, stageId, data) => {
  const endpoint = `/drip/campaign/${campaignId}/stage/${stageId}`;
  return putMainApi(data, endpoint);
};
export const removeTrigger = (campaignId, triggerId) => {
  const endpoint = `/drip/campaign/${campaignId}/trigger/${triggerId}`;
  return deleteMainApi(endpoint);
};
export const removeEmail = (campaignId, stageId) => {
  const endpoint = `/drip/campaign/${campaignId}/stage/${stageId}`;
  return deleteMainApi(endpoint);
};
export const deleteDripCampaign = campaignId => {
  const endpoint = `/drip/campaign/${campaignId}`;
  return deleteMainApi(endpoint);
};
export const deleteClientFromCampaign = (campaignId, clientProfileId) => {
  const endpoint = `/drip/campaign/${campaignId}/client/${clientProfileId}`;
  return deleteMainApi(endpoint);
};
export const bulkDeleteClientsFromCampaign = (campaignId, clientIds = []) => {
  const endpoint = `/drip/campaign/${campaignId}/client/remove`;
  return postMainApi({
    clientIds
  }, endpoint);
};